import { IApplicationState } from '../../types/redux';
import { getFilters } from '../filters';
import { isMoscowOrMO } from '../../utils/isMoscowOrMO';

export function selectIsMoscowOrMO(state: IApplicationState) {
  const { location } = getFilters(state);

  return isMoscowOrMO(location);
}
